import type {ReactElement} from 'react';
import React from 'react';
import {useGetSelectedTranscriptItem} from '@Hooks/poster-editor/useGetSelectedTranscriptItem';
import type {RGBA} from '@Utils/color.util';
import {BaseOutlineColorPanel} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-outline-color-panel';
import {useGetKeyFromSubtitleTextStylesForTranscriptItem} from '@Hooks/poster-editor/useGetKeyFromSubtitleTextStylesForTranscriptItem';

export function TranscriptActiveWordOutlineColorPanel(): ReactElement {
  const activeItem = useGetSelectedTranscriptItem();
  if (activeItem === null) {
    throw new Error('Transcript Item is undefined in TranscriptActiveWordOutlineColorPanel');
  }

  const strokeColor = useGetKeyFromSubtitleTextStylesForTranscriptItem('strokeColor', true);
  if (strokeColor === undefined) {
    throw new Error('Transcript Item does not have strokeColor property in activeWordTextStyles');
  }

  const onActiveWordStrokeColorChange = (strokeColor: RGBA, undoable = true): void => {
    void activeItem.updateAllSubtitlesStylesFromSubtitleObject(
      {
        activeWordTextStyles: {
          strokeColor,
        },
      },
      {undoable}
    );
  };

  return <BaseOutlineColorPanel strokeColor={strokeColor} onUpdateStrokeColor={onActiveWordStrokeColorChange} />;
}
